/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */
/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useState, useEffect } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModalFormRisk_level from "../components/ModalFormRisk_level";
import Swal from "sweetalert2";
import { FaArrowAltCircleLeft, FaLaughBeam, FaFrown } from "react-icons/fa";
import No_image from "../img/No_Image.jpg";
// import { Button } from "react-bootstrap";
import {
  isValidTimeFormat,
  thai_date,
  checkGroupsUser,
  getlocalStorage,
} from "../function/functionALL";
import Layout from "../components/Layout";
import LoadingPage from "../components/LoadingPage";

require("moment/locale/th");

const PageTestScore = () => {
  const location = useLocation();
  const {
    Budget_year,
    Round,
    DateTest,
    Tester,
    round_detail,
    txt_search,
    unit_name,
    pageNumber,
    AmountPage,
    checkstatus,
  } = location.state;
  const { budget_year, round, date } = round_detail;
  const navigate = useNavigate();

  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;

  const [Bodydata, setBodydata] = useState([]);
  const [Datapushup, setpushup] = useState([]);
  const [Datarun, setDatarun] = useState([]);
  const [Datasitup, setDatasitup] = useState([]);
  const [Datawalk, setDatawalk] = useState([]);
  const [Totalscore, setTotalscore] = useState([]);
  const [Isairworker, setIsairworker] = useState([]);
  // const [loadingTable, setloadingTable] = useState(true); ////ทำงาน
  const [loadingpage, setLoadingpage] = useState(true);

  const imageSource = Tester.tester_image
    ? process.env.REACT_APP_API_IMG + Tester.tester_image
    : No_image;
  // active toggle
  const [SelectedToggle, setSelectedToggle] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoadingpage(true);
      const res = await Axios.get(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );
      console.log("res: ", res.data);

      setBodydata(res.data.body_data);
      setpushup(res.data.pushup);
      setDatarun(res.data.run);
      setDatasitup(res.data.situp);
      setDatawalk(res.data.walk);
      setLoadingpage(false);
      setTotalscore(res.data.total_score);
      setIsairworker(res.data.is_air_worker);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      } else {
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      }
    }
  };

  //toggle
  const [selectedElement, setSelectedElement] = useState("");
  const handleButtonClick = (element) => {
    if (selectedElement === element) {
      setSelectedElement("");
    } else {
      setSelectedElement(element);
    }
    setSelectedToggle(element);
  };

  const UpdateScoreSitup_Test = (e) => {
    let timerInterval;

    const edit = e.target.value;
    if (edit === "" || edit === "0") {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          situp: {
            quantity: -1,
            recorder_id: 0,
            score: -1,
            recorder_fullname: "-",
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>ลบข้อมูลเรียบร้อย</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    } else if (edit.length > 3) {
      Swal.fire({
        icon: "warning",
        title: "บันทึกข้อมูลไม่สำเร็จ!",
      });
    } else {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          situp: {
            quantity: edit,
            recorder_id: DataToken_.id,
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>สถานีลุกนั่งทำได้ ${res.data.situp.quantity} ครั้ง</div><div>ได้คะแนน ${res.data.situp.score} คะแนน</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    }
  };
  const UpdateScorePushup_Test = (e) => {
    const edit = e.target.value;
    let timerInterval;

    if (edit === "" || edit === "0") {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          pushup: {
            quantity: -1,
            recorder_id: 0,
            score: -1,
            recorder_fullname: "-",
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>ลบข้อมูลเรียบร้อย</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    } else if (edit.length > 3) {
      Swal.fire({
        icon: "warning",
        title: "บันทึกข้อมูลไม่สำเร็จ!",
      });
    } else {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          pushup: {
            quantity: edit,
            recorder_id: DataToken_.id,
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>สถานีดันพื้นทำได้ ${res.data.pushup.quantity} ครั้ง</div><div>ได้คะแนน ${res.data.pushup.score} คะแนน</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    }
  };

  const UpdateScoreRun_Test = (e) => {
    const edit = e.target.value;
    let timerInterval;

    if (edit === "" || edit === "0") {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          run: {
            quantity: "-1:59",
            recorder_id: 0,
            score: -1,
            recorder_fullname: "-",
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>ลบข้อมูลเรียบร้อย</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    } else if (!isValidTimeFormat(edit)) {
      Swal.fire({
        icon: "warning",
        title: "บันทึกข้อมูลไม่สำเร็จ!",
      });
    } else {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          run: {
            quantity: edit,
            recorder_id: DataToken_.id,
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>สถานีวิ่ง ทำได้ ${res.data.run.quantity} นาที</div><div>ได้คะแนน ${res.data.run.score} คะแนน</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    }
  };
  const UpdateScoreWalk_Test = (e) => {
    const edit = e.target.value;
    let timerInterval;

    if (edit === "" || edit === "0") {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          walk: {
            quantity: "-1:59",
            recorder_id: 0,
            score: -1,
            recorder_fullname: "-",
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>ลบข้อมูลเรียบร้อย</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    } else if (!isValidTimeFormat(edit)) {
      Swal.fire({
        icon: "warning",
        title: "บันทึกข้อมูลไม่สำเร็จ!",
      });
    } else {
      Axios.patch(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          walk: {
            quantity: edit,
            recorder_id: DataToken_.id,
          },
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            html: `<div>สถานีเดิน ทำได้ ${res.data.walk.quantity} นาที</div><div>ได้คะแนน ${res.data.walk.score} คะแนน</div>`,
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                // b.textContent = Swal.getTimerLeft();
              }, 100);
            },
          }).then((result) => {
            navigate(0);
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate("/notfound404");
          }
          console.error(err);

          Swal.fire({
            icon: "error",
          });
        });
    }
  };

  return (
    <>
      <Layout>
        {loadingpage ? (
          <LoadingPage />
        ) : (
          <div>
            <Form>
              <div className="App login-box">
                <section
                  style={{
                    backgroundImage: `url(${bg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    backgroundSize: "cover",
                    minHeight: "1180px",
                  }}
                >
                  <div
                    className="mb-0 rounded"
                    style={{ padding: "68px 0 0 0" }}
                  >
                    <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3">
                      <div className="p-3">
                        <div
                          className="card col-sm-12 col-xs-12"
                          style={{ backgroundColor: "rgb(247, 247, 247, 0.8)" }}
                        >
                          <div className="card-body rounded ">
                            <div className=" row d-flex p-2">
                              <div
                                className=" col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3 d-flex p-0 mt-2"
                                style={{ color: "#000000" }}
                              >
                                <div className="col-3 col-sm-3 text-start">
                                  <Link
                                    to={`/PageTestRound`}
                                    state={{
                                      Tester: Tester,
                                      props_RoundTest: round_detail,
                                      txt_search: txt_search,
                                      unit_name: unit_name,
                                      props_pageNumber: pageNumber,
                                      props_AmountPage: AmountPage
                                    }}
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                      display: "inline-block",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-primary m-0 d-none d-md-block px-4"
                                      style={{
                                        backgroundColor:
                                          "rgb(2, 117, 216,0.80)",
                                        border: "none",
                                      }}
                                    >
                                      {" "}
                                      ย้อนกลับ
                                    </button>
                                  </Link>
                                  <Link
                                    to={`/PageTestRound`}
                                    state={{
                                      Tester: Tester,
                                      props_RoundTest: round_detail,
                                      txt_search: txt_search,
                                      unit_name: unit_name,
                                      props_pageNumber: pageNumber,
                                      props_AmountPage: AmountPage,
                                    }}
                                    className="d-md-none"
                                  >
                                    <FaArrowAltCircleLeft
                                      style={{
                                        fontSize: "22px",
                                        color: "#3399FF",
                                      }}
                                      className="mt-2 d-md-none"
                                    />{" "}
                                  </Link>
                                </div>
                                <div
                                  className="col-6 fw-bold col-sm-6"
                                  style={{ fontSize: "25px" }}
                                >
                                  การทดสอบ
                                </div>
                              </div>
                              <div
                                className="col-sm-12 text-center fw-bold mb-3"
                                style={{ fontSize: "16px" }}
                              >
                                ปีงบประมาณ {Budget_year || budget_year} รอบที่{" "}
                                {Round || round} {"("}
                                {thai_date(DateTest || date, "shortdate")}
                                {")"}
                              </div>
                              <hr></hr>
                            </div>
                            <div style={{ width: "90%", margin: "0 0 0 5%" }}>
                              {/* <div style={{ width: "80%", margin: "0 10% 0 10%" }} > */}
                              <div
                                className="row px-2 d-flex flex-row card shadow-lg justify-content-center"
                                style={{
                                  backgroundImage: `url(${bg})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "100% 100%",
                                  color: "#000000",
                                }}
                              >
                                <div className="p-3 col-12 col-sm-12 col-md-4 col-lg-4 text-center align-items-center">
                                  <div className="mt-4 text-center">
                                    <img
                                      src={imageSource}
                                      alt="Profile"
                                      className="rounded img-fluid"
                                      style={{ maxHeight: "250px" }}
                                    />
                                  </div>
                                </div>
                                <div className="p-sm-3 p-1 col-12 col-sm-12 col-md-8 col-lg-5 mb-2">
                                  <div
                                    className="tab-pane fade show active profile-overview w-100"
                                    id="profile-overview"
                                  >
                                    <div className="col-12 col-sm-12">
                                      <div
                                        className="fw-bold text-center fs-5"
                                        style={{ color: "#000000" }}
                                      >
                                        ข้อมูล
                                      </div>
                                    </div>
                                    <div
                                      className="p-3 col-12 col-sm-12 col-md-12"
                                      style={{ fontSize: "16px" }}
                                    >
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          ชื่อ :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Tester.tester_fullname}
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          ตำแหน่ง :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Tester.tester_position}
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          สังกัด :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Tester.work_unit_shortname}
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          อายุ :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Tester.tester_age} ปี
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          น้ำหนัก :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Bodydata.weight === ""
                                            ? "-"
                                            : `${Bodydata.weight} กิโลกรัม`}
                                          {/* {Bodydata.weight === "" ? "-" : Bodydata.weight} กิโลกรัม */}
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          ส่วนสูง :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Bodydata.height === ""
                                            ? "-"
                                            : `${Bodydata.height} เซนติเมตร`}
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          BMI :{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Bodydata.bmi === ""
                                            ? "-"
                                            : `${Bodydata.bmi}`}
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 ms-2 d-flex">
                                        <div className="col-5 col-sm-3 col-md-4 fw-bold">
                                          ผู้ฏิบัติงาน:{" "}
                                        </div>
                                        <div className="col-8 col-sm-9 label">
                                          {Isairworker === false
                                            ? "ภาคพื้น"
                                            : "ภาคอากาศ"}
                                        </div>
                                      </div>
                                    </div>
                                    {/* <ModalFormRisk_level
                                    Tester= {Tester}

                                    Id_test={Id_test}
                                    Budget_year={Budget_year || budget_year}
                                    Round={Round || round}
                                    DateTest={DateTest||date}
                                    Risk_level={Tester.risk_score}
                                    Tester_fullname={Tester.tester_fullname}
                                    Tester_position={Tester.tester_position}
                                    Tester_age={Tester.tester_age}
                                    Pushup_quantity={Datapushup.quantity}
                                    Pushup_score={Datapushup.score}
                                    Pushup_recorder_id={Datapushup.recorder_id}
                                    Run_quantity={Datarun.quantity}
                                    Run_score={Datarun.score}
                                    Run_recorder_id={Datarun.recorder_id}
                                    Situp_quantity={Datasitup.quantity}
                                    Situp_score={Datasitup.score}
                                    Situp_recorder_id={Datasitup.recorder_id}
                                    Walk_quantity={Datawalk.quantity}
                                    Walk_score={Datawalk.score}
                                    Walk_recorder_id={Datawalk.recorder_id}
                                  /> */}
                                  </div>
                                </div>
                              </div>

                              <div className="text-center row ">
                                <div
                                  className=" col-4 col-sm-4 mt-1"
                                  style={{ padding: "0 0.8px 0 0.8px" }}
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    style={{
                                      borderTop: "none",
                                      borderLeft: "none",
                                      borderRight: "none",
                                      borderBottom:
                                        SelectedToggle === "Pushup"
                                          ? "6px solid black"
                                          : "none",
                                      borderRadius: "5px",
                                      height: "40px",
                                      fontSize: "14px",
                                      color: "black",
                                      fontWeight: "500",
                                      backgroundColor:
                                        Datapushup.quantity === -1
                                          ? "RGB(255, 181, 69,0.90)" //สีเหลือง
                                          : Datapushup.quantity <
                                            Datapushup.pass_quantity
                                          ? "RGB(255, 0, 0,0.60)" //แดง
                                          : "RGB(124, 179, 66,0.80)", //เขียว
                                    }}
                                    onClick={() => handleButtonClick("Pushup")}
                                  >
                                    ดันพื้น
                                  </button>
                                </div>

                                <div
                                  className="col-4 col-sm-4 mt-1"
                                  style={{ padding: "0 0.8px 0 0.8px" }}
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    style={{
                                      borderTop: "none",
                                      borderLeft: "none",
                                      borderRight: "none",
                                      borderBottom:
                                        SelectedToggle === "Situp"
                                          ? "6px solid black"
                                          : "none",
                                      borderRadius: "5px",
                                      height: "40px",
                                      fontSize: "14px",
                                      color: "black",
                                      fontWeight: "500",
                                      backgroundColor:
                                        Datasitup.quantity === -1
                                          ? "RGB(255, 181, 69,0.90)"
                                          : Datasitup.quantity <
                                            Datasitup.pass_quantity
                                          ? "RGB(255, 0, 0,0.60)" //แดง
                                          : "RGB(124, 179, 66,0.80)", //เขียว
                                    }}
                                    onClick={() => handleButtonClick("Situp")}
                                  >
                                    ลุกนั่ง
                                  </button>
                                </div>
                                <div
                                  className="col-4 col-sm-4 mt-1"
                                  style={{ padding: "0 0.8px 0 0.8px" }}
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    style={{
                                      borderTop: "none",
                                      borderLeft: "none",
                                      borderRight: "none",
                                      borderBottom:
                                        SelectedToggle === "Walk_Run"
                                          ? "6px solid black"
                                          : "none",
                                      borderRadius: "5px",
                                      height: "40px",
                                      fontSize: "16px",
                                      color: "black",
                                      fontWeight: "500",
                                      backgroundColor:
                                        (parseFloat(Datarun.quantity) ===
                                          "-1:59" ||
                                          parseFloat(Datarun.quantity) ===
                                            -1) &&
                                        (parseFloat(Datawalk.quantity) ===
                                          "-1:59" ||
                                          parseFloat(Datawalk.quantity) === -1)
                                          ? "RGB(255, 181, 69,0.90)"
                                          : parseFloat(Datarun.quantity) >
                                              parseFloat(
                                                Datarun.pass_quantity
                                              ) ||
                                            parseFloat(Datawalk.quantity) >
                                              parseFloat(Datawalk.pass_quantity)
                                          ? "RGB(255, 0, 0,0.60)" //แดง
                                          : "RGB(124, 179, 66,0.80)", //เขียว
                                    }}
                                    onClick={() =>
                                      handleButtonClick("Walk_Run")
                                    }
                                  >
                                    วิ่ง/เดิน
                                  </button>
                                </div>
                              </div>

                              {(selectedElement === "Walk_Run" ||
                                selectedElement === "Run" ||
                                selectedElement === "Walk") && (
                                <div className="row d-flex justify-content-end pt-1">
                                  <div className="col-12 col-sm-4 col-lg-4 d-flex p-0 m-0">
                                    <button
                                      type="button"
                                      className="btn btn-primary w-100 "
                                      style={{
                                        borderTop: "none",
                                        borderLeft: "none",
                                        borderRight: "none",
                                        borderBottom:
                                          SelectedToggle === "Run"
                                            ? "6px solid black"
                                            : "none",
                                        borderRadius: "5px",
                                        height: "40px",
                                        fontSize: "16px",
                                        color: "black",
                                        fontWeight: "500",
                                        backgroundColor:
                                          parseFloat(Datarun.quantity) ===
                                            "-1:59" ||
                                          parseFloat(Datarun.quantity) === -1
                                            ? "RGB(255, 181, 69,0.90)"
                                            : parseFloat(Datarun.quantity) >
                                              parseFloat(Datarun.pass_quantity)
                                            ? "RGB(255, 0, 0,0.60)" //แดง
                                            : "RGB(124, 179, 66,0.80)", //เขียว
                                      }}
                                      disabled={
                                        Datawalk.quantity !== "-1:59" &&
                                        Datawalk.quantity !== -1
                                      }
                                      onClick={() => handleButtonClick("Run")}
                                    >
                                      วิ่ง
                                    </button>

                                    <button
                                      type="button"
                                      className="btn btn-primary w-100"
                                      style={{
                                        borderTop: "none",
                                        borderLeft: "none",
                                        borderRight: "none",
                                        borderBottom:
                                          SelectedToggle === "Walk"
                                            ? "6px solid black"
                                            : "none",
                                        borderRadius: "5px",
                                        height: "40px",
                                        fontSize: "16px",
                                        color: "black",
                                        fontWeight: "500",
                                        backgroundColor:
                                          parseFloat(Datawalk.quantity) ===
                                            "-1:59" ||
                                          parseFloat(Datawalk.quantity) === -1
                                            ? "RGB(255, 181, 69,0.90)"
                                            : parseFloat(Datawalk.quantity) >
                                              parseFloat(Datawalk.pass_quantity)
                                            ? "RGB(255, 0, 0,0.60)" //แดง
                                            : "RGB(124, 179, 66,0.80)", //เขียว
                                      }}
                                      disabled={
                                        Datarun.quantity !== "-1:59" &&
                                        Datarun.quantity !== -1
                                      }
                                      onClick={() => handleButtonClick("Walk")}
                                    >
                                      เดิน
                                    </button>
                                  </div>
                                </div>
                              )}
                              <br></br>
                              <div
                                className="col-md-12 ms-sm-1 text-center fw-bold"
                                style={{ fontSize: "22px", color: "black" }}
                              >
                                รายการทดสอบ
                              </div>

                              <div>
                                {/* ---------------------- */}
                                {selectedElement === "Situp" && (
                                  <div className="row col-md-12 ms-sm-1 ">
                                    <div
                                      className="text-center fw-bold mt-3"
                                      style={{ fontSize: "18px" }}
                                    >
                                      การทดสอบ ลุกนั่ง (Situp)
                                    </div>
                                    <div
                                      className="text-center fw-bold mb-2"
                                      style={{ fontSize: "16px" }}
                                    >
                                     
                                      ต้องทำอย่างน้อย{" "}{Datasitup.pass_quantity} ครั้ง (เต็ม 50 ครั้ง)

                                    </div>
                                    <hr></hr>
                                    <div className="col-12 col-sm-6 mt-2 mb-2 d-flex justify-content-center">
                                      <div className="col-7 col-sm-6">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          จำนวนครั้งที่ได้ (ครั้ง)
                                        </label>
                                      </div>
                                      <div className="col-5 col-sm-6 d-flex align-items-center ps-sm-1">
                                        {role_openRole?.FunctionaryTester ||
                                        role_openRole?.UnitAdmin ? (
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="inputText"
                                            placeholder="กรอกจำนวนครั้ง"
                                            defaultValue={
                                              Datasitup.quantity === -1
                                                ? ""
                                                : Datasitup.quantity
                                            }
                                            name="quantitysitup"
                                            onBlur={(e) =>
                                              UpdateScoreSitup_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled={checkstatus === 0}
                                          ></input>
                                        ) : (
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="inputText"
                                            placeholder="ยังไม่ได้ลงคะแนน"
                                            defaultValue={
                                              Datasitup.quantity === -1
                                                ? ""
                                                : Datasitup.quantity
                                            }
                                            name="quantitysitup"
                                            onBlur={(e) =>
                                              UpdateScoreSitup_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled
                                          ></input>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-12 col-sm-6 mt-2 mb-3 d-flex justify-content-center align-items-center">
                                      <label className="col-7 col-sm-6 col-form-label fw-bold text-sm-center">
                                        คะแนนที่ได้
                                      </label>
                                      <div className="col-5 col-sm-6">
                                        {Datasitup.score === -1 ? (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText2"
                                            defaultValue="0"
                                            disabled
                                          ></input>
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText"
                                            defaultValue={Datasitup.score}
                                            disabled
                                          ></input>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-2 mb-3 d-flex justify-content-center">
                                      <div className="col-6 col-sm-3">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          ผู้บันทึกคะแนน
                                        </label>
                                      </div>
                                      <div className="col-6 col-sm-9 d-flex align-items-center">
                                        {Datasitup.recorder_fullname}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* ---------------------- */}
                                {selectedElement === "Pushup" && (
                                  <div className="row col-md-12 ms-sm-1">
                                    <div
                                      className="text-center fw-bold mt-3"
                                      style={{ fontSize: "18px" }}
                                    >
                                      การทดสอบ ดันพื้น (Pushup)
                                    </div>
                                    <div
                                      className="text-center fw-bold mb-2"
                                      style={{ fontSize: "16px" }}
                                    >
                                      ต้องทำอย่างน้อย{" "}{Datapushup.pass_quantity} ครั้ง (เต็ม 50 ครั้ง)
                                       
                                    </div>
                                    <hr></hr>
                                    <div className="col-12 col-sm-6 mt-2 mb-2 d-flex justify-content-center">
                                      <div className="col-7 col-sm-6">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          จำนวนครั้งที่ได้ (ครั้ง)
                                        </label>
                                      </div>
                                      <div className="col-5 col-sm-6 d-flex align-items-center ps-sm-1">
                                        {role_openRole?.FunctionaryTester ||
                                        role_openRole?.UnitAdmin ? (
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="inputText4"
                                            placeholder="กรอกจำนวนครั้ง"
                                            defaultValue={
                                              Datapushup.quantity === -1
                                                ? ""
                                                : Datapushup.quantity
                                            }
                                            onBlur={(e) =>
                                              UpdateScorePushup_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled={checkstatus === 0}
                                          ></input>
                                        ) : (
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="inputText4"
                                            placeholder="ยังไม่ได้ลงคะแนน"
                                            defaultValue={
                                              Datapushup.quantity === -1
                                                ? ""
                                                : Datapushup.quantity
                                            }
                                            onBlur={(e) =>
                                              UpdateScorePushup_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled
                                          ></input>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-12 col-sm-6 mt-2 mb-3 d-flex justify-content-center align-items-center">
                                      <label className="col-7 col-sm-6 col-form-label fw-bold text-sm-center">
                                        คะแนนที่ได้
                                      </label>
                                      <div className="col-5 col-sm-6">
                                        {Datapushup.score === -1 ? (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText5"
                                            defaultValue="0"
                                            disabled
                                          ></input>
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText"
                                            defaultValue={Datapushup.score}
                                            disabled
                                          ></input>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-2 mb-3 d-flex justify-content-center">
                                      <div className="col-6 col-sm-3">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          ผู้บันทึกคะแนน
                                        </label>
                                      </div>
                                      <div className="col-6 col-sm-9 d-flex align-items-center">
                                        {Datapushup.recorder_fullname}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* ---------------------- */}
                                {selectedElement === "Run" && (
                                  <div className="row col-md-12 ms-sm-1">
                                    <p
                                      className="text-center"
                                      style={{ fontSize: "16px" }}
                                    >
                                      กรณีต้องการเปลี่ยนแปลงสถานีวิ่งหรือเดิน
                                      ให้ลบคะแนนสถานีนั้นๆก่อน
                                    </p>
                                    <div
                                      className="text-center fw-bold mt-3"
                                      style={{ fontSize: "18px" }}
                                    >
                                      การทดสอบ วิ่ง 2.4 กม. (Run)
                                    </div>
                                    <div
                                      className="text-center fw-bold mb-2"
                                      style={{ fontSize: "14px" }}
                                    >
                                  
                                     ต้องทำเวลาไม่เกิน  {Datarun.pass_quantity} นาที (เต็ม 13:00 นาที)
                                    </div>

                                    <hr></hr>
                                    <div className="col-12 col-sm-6 mt-2 mb-2 d-flex justify-content-center">
                                      <div className="col-7 col-sm-6">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          เวลาที่ทำได้/นาที
                                        </label>
                                      </div>
                                      <div className="col-5 col-sm-6 align-items-center ps-sm-1">
                                        {role_openRole?.FunctionaryTester ||
                                        role_openRole?.UnitAdmin ? (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText7"
                                            placeholder="ตัวอย่างการกรอก 12:30"
                                            defaultValue={
                                              Datarun.quantity === "-1:59" ||
                                              Datarun.quantity === -1
                                                ? ""
                                                : Datarun.quantity
                                            }
                                            onBlur={(e) =>
                                              UpdateScoreRun_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled={checkstatus === 0}
                                          ></input>
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText7"
                                            placeholder="ยังไม่ได้ลงคะแนน"
                                            defaultValue={
                                              Datarun.quantity === "-1:59" ||
                                              Datarun.quantity === -1
                                                ? ""
                                                : Datarun.quantity
                                            }
                                            onBlur={(e) =>
                                              UpdateScoreRun_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled
                                          ></input>
                                        )}
                                        <label
                                          className="col-12 col-sm-9 col-form-label"
                                          style={{ fontSize: "15px" }}
                                        >
                                          (ตัวอย่าง 12:30,12.30)
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-12 col-sm-6 mt-2 mb-3 d-flex justify-content-center">
                                      <label className="col-7 col-sm-6 col-form-label fw-bold text-sm-center">
                                        คะแนนที่ได้
                                      </label>
                                      <div className="col-5 col-sm-6">
                                        {Datarun.score === -1 ? (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText"
                                            defaultValue="0"
                                            disabled
                                          ></input>
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText"
                                            defaultValue={Datarun.score}
                                            disabled
                                          ></input>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-2 mb-3 d-flex justify-content-center">
                                      <div className="col-6 col-sm-3">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          ผู้บันทึกคะแนน
                                        </label>
                                      </div>
                                      <div className="col-6 col-sm-9 d-flex align-items-center">
                                        {Datarun.recorder_fullname}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* ---------------------- */}
                                {selectedElement === "Walk" && (
                                  <div className="row col-md-12 ms-sm-1">
                                    <p
                                      className="text-center"
                                      style={{ fontSize: "16px" }}
                                    >
                                      กรณีต้องการเปลี่ยนแปลงสถานีวิ่งหรือเดิน
                                      ให้ลบคะแนนสถานีนั้นๆก่อน
                                    </p>
                                    <div
                                      className="text-center fw-bold mt-3"
                                      style={{ fontSize: "18px" }}
                                    >
                                      การทดสอบ เดิน 3.2 กม. (Walk)
                                    </div>
                                    <div
                                      className="text-center fw-bold mb-2"
                                      style={{ fontSize: "14px" }}
                                    >
                                      ต้องทำเวลาไม่เกิน  {Datawalk.pass_quantity} นาที (เต็ม 13:00 นาที)
                                    </div>

                                    <hr></hr>
                                    <div className="col-12 col-sm-6 mt-2 mb-2 d-flex justify-content-center">
                                      <div className="col-7 col-sm-6">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          เวลาที่ทำได้/นาที
                                        </label>
                                      </div>
                                      <div className="col-5 col-sm-6 align-items-center ps-sm-1">
                                        {role_openRole?.FunctionaryTester ||
                                        role_openRole?.UnitAdmin ? (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText9"
                                            placeholder="ตัวอย่างการกรอก 12:30"
                                            defaultValue={
                                              Datawalk.quantity === "-1:59" ||
                                              Datawalk.quantity === -1
                                                ? ""
                                                : Datawalk.quantity
                                            }
                                            onBlur={(e) =>
                                              UpdateScoreWalk_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled={checkstatus === 0}
                                          ></input>
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText9"
                                            placeholder="ยังไม่ได้ลงคะแนน"
                                            defaultValue={
                                              Datawalk.quantity === "-1:59" ||
                                              Datawalk.quantity === -1
                                                ? ""
                                                : Datawalk.quantity
                                            }
                                            onBlur={(e) =>
                                              UpdateScoreWalk_Test(
                                                e,
                                                e.target.value
                                              )
                                            }
                                            disabled
                                          ></input>
                                        )}
                                        <label
                                          className="col-12 col-sm-9 col-form-label"
                                          style={{ fontSize: "15px" }}
                                        >
                                          (ตัวอย่าง 12:30,12.30)
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-6 mt-2 mb-3 d-flex justify-content-center ">
                                      <label className="col-7 col-sm-6 col-form-label fw-bold text-sm-center">
                                        คะแนนที่ได้
                                      </label>
                                      <div className="col-5 col-sm-6">
                                        {Datawalk.score === -1 ? (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText"
                                            defaultValue="0"
                                            disabled
                                          ></input>
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="inputText"
                                            defaultValue={Datawalk.score}
                                            disabled
                                          ></input>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-2 mb-3 d-flex justify-content-center">
                                      <div className="col-6 col-sm-3">
                                        <label className="col-12 col-sm-12 col-form-label fs-6">
                                          ผู้บันทึกคะแนน
                                        </label>
                                      </div>
                                      <div className="col-6 col-sm-9 d-flex align-items-center">
                                        {Datawalk.recorder_fullname}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* ---------------------- */}
                              </div>

                              <hr></hr>

                              {(Datasitup.quantity !== -1 &&
                                Datapushup.quantity !== -1 &&
                                Datarun.quantity !== "-1:59" &&
                                Datarun.quantity !== -1) ||
                              (Datasitup.quantity !== -1 &&
                                Datapushup.quantity !== -1 &&
                                Datawalk.quantity !== "-1:59" &&
                                Datawalk.quantity !== -1) ? (
                                <div className="mt-3 justify-content-center ms-2">
                                  <div className="text-center pt-1">
                                    {Totalscore >= 150 &&
                                    Isairworker === false ? (
                                      <div
                                        style={{
                                          fontSize: "18px",
                                          color: "#7cb342",
                                        }}
                                      >
                                        <b>
                                          รวมคะแนนที่ได้ คือ {Totalscore}{" "}
                                          <div>
                                            {"( "}ผ่าน <FaLaughBeam />
                                            {" ) "}
                                          </div>
                                        </b>
                                      </div>
                                    ) : Totalscore >= 210 &&
                                      Isairworker === true ? (
                                      <div
                                        style={{
                                          fontSize: "18px",
                                          color: "#7cb342",
                                        }}
                                      >
                                        <b>
                                          รวมคะแนนที่ได้ คือ {Totalscore}{" "}
                                          <div>
                                            {"( "}ผ่าน <FaLaughBeam />
                                            {" ) "}
                                          </div>
                                        </b>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          fontSize: "18px",
                                          color: "red",
                                        }}
                                      >
                                        <b>
                                          รวมคะแนนที่ได้ คือ {Totalscore}{" "}
                                          <div>
                                            {"( "}ไม่ผ่าน <FaFrown />
                                            {" ) "}
                                          </div>
                                        </b>
                                      </div>
                                    )}
                                  </div>{" "}
                                  <br></br>
                                </div>
                              ) : Datasitup.quantity === -1 ||
                                Datapushup.quantity === -1 ||
                                Datarun.quantity === "-1:59" ||
                                Datarun.quantity === -1 ||
                                Datasitup.quantity === -1 ||
                                Datapushup.quantity === -1 ||
                                Datawalk.quantity === "-1:59" ||
                                Datawalk.quantity === -1 ? (
                                <div className="text-center pt-1">
                                  <div
                                    style={{ fontSize: "18px", color: "red" }}
                                  >
                                    <b>ทดสอบไม่ครบทั้ง 3 สถานี </b>
                                    {/* <div>
                                  {"( "}ไม่ผ่าน <FaFrown />
                                  {" ) "}
                                </div> */}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Form>
          </div>
        )}
      </Layout>
    </>
  );
};

export default PageTestScore;
